import ReactDOM from "react-dom"
import React, { useState, useEffect } from "react"
import MainWrapper from "../../helpers/MainWrapper"
import MainHeader from "./MainHeader"
import "./styles.less"
import Contacts from "./Contacts"
import Faq from "./FAQ"

declare var root: any

const AboutUs = () => {
  return (
    <>
      <MainHeader />
    </>
  )
}

if (root) {
  ReactDOM.render(
    <MainWrapper menus={true}>
      <AboutUs />
      <Contacts />
      <Faq />
    </MainWrapper>,
    root
  )
}
